import { useMemo } from 'react'

import { useFetchCommandsByObjectCodeQuery, useFetchCommandsBySystemCodeQuery } from '@redux/api'

import { createAutocompleteOptions, isObjectSource, isSystemSource } from '@helpers'
import { TYPES_SOURCE_OPTIONS } from '@constants'

interface IProps {
  sourceCommand: string | number | undefined
  currentSourceType: TYPES_SOURCE_OPTIONS
}

export const useCommands = ({ sourceCommand, currentSourceType }: IProps) => {
  const { data: commandsObject, isLoading: isLoadingObjectCommands } =
    useFetchCommandsByObjectCodeQuery(String(sourceCommand), {
      skip: !sourceCommand || !isObjectSource(currentSourceType),
    })

  const { data: commandsSystem, isLoading: isLoadingSystemCommands } =
    useFetchCommandsBySystemCodeQuery(String(sourceCommand), {
      skip: !sourceCommand || !isSystemSource(currentSourceType),
    })

  const commandsData = isObjectSource(currentSourceType) ? commandsObject : commandsSystem

  const commandOptions = useMemo(
    () =>
      commandsData
        ? createAutocompleteOptions(commandsData, {
            id: 'code',
            label: 'code',
            httpMethod: 'httpMethod',
          })
        : [],
    [commandsData]
  )

  const isLoadingCommandOptions = isLoadingObjectCommands || isLoadingSystemCommands

  return {
    commandOptions,
    commandsData,
    commandsSystem,
    commandsObject,
    isLoadingCommandOptions,
  }
}
